(() => {
  const drawer = document.querySelector("[data-cart-drawer]");
  const overlay = document.querySelector("[data-drawer-overlay]");
  const itemsContainer = document.querySelector("[data-cart-items]");
  const footer = document.querySelector("[data-cart-footer]");
  const total = document.querySelector("[data-cart-total]");
  const countNodes = document.querySelectorAll("[data-cart-count]");
  const toast = document.querySelector("[data-toast]");
  const mobileMenu = document.querySelector("[data-mobile-menu]");
  const header = document.querySelector("[data-header]");

  const money = (cents) => new Intl.NumberFormat(window.Vitier.locale || "en", {
    style: "currency", currency: window.Vitier.currency || "USD"
  }).format(cents / 100);
  const escapeHtml = (value) => String(value).replaceAll("&", "&amp;").replaceAll("<", "&lt;").replaceAll(">", "&gt;").replaceAll('"', "&quot;").replaceAll("'", "&#039;");

  function updateHeader() {
    if (!header || header.classList.contains("header-solid")) return;
    header.classList.toggle("is-scrolled", window.scrollY > 32);
  }
  function setDrawer(open) {
    if (!drawer || !overlay) return;
    drawer.classList.toggle("open", open); overlay.classList.toggle("open", open);
    drawer.setAttribute("aria-hidden", String(!open)); document.body.classList.toggle("locked", open);
  }
  function renderCart(cart) {
    countNodes.forEach((node) => { node.textContent = cart.item_count; });
    footer.hidden = cart.item_count === 0; total.textContent = money(cart.total_price);
    if (!cart.items.length) { itemsContainer.innerHTML = '<div class="empty-cart">Your bag is empty.</div>'; return; }
    itemsContainer.innerHTML = cart.items.map((item, index) => `<div class="cart-line">
      ${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}">` : ""}
      <div><p>Quantity ${item.quantity}</p><h3><a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a></h3><strong>${money(item.final_line_price)}</strong></div>
      <button type="button" data-remove-line="${index + 1}">Remove</button></div>`).join("");
  }
  async function getCart() {
    const response = await fetch(`${window.Vitier.routes.cart}.js`, { headers: { Accept: "application/json" } });
    const cart = await response.json(); renderCart(cart); return cart;
  }
  async function addToCart(button) {
    button.disabled = true;
    try {
      const response = await fetch(`${window.Vitier.routes.cartAdd}.js`, {
        method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] })
      });
      if (!response.ok) throw new Error("Unable to add this item.");
      await getCart(); setDrawer(true); toast?.classList.add("show"); window.setTimeout(() => toast?.classList.remove("show"), 1500);
    } catch (error) {
      const text = toast?.querySelector("span"); if (text) text.textContent = error.message;
      toast?.classList.add("show"); window.setTimeout(() => { toast?.classList.remove("show"); if (text) text.textContent = "Added to your bag"; }, 2200);
    } finally { button.disabled = false; }
  }

  document.addEventListener("click", async (event) => {
    const addButton = event.target.closest("[data-add-to-cart]");
    if (addButton) { event.preventDefault(); await addToCart(addButton); return; }
    const removeButton = event.target.closest("[data-remove-line]");
    if (removeButton) {
      removeButton.disabled = true;
      await fetch(`${window.Vitier.routes.cartChange}.js`, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ line: Number(removeButton.dataset.removeLine), quantity: 0 }) });
      await getCart(); return;
    }
    if (event.target.closest("[data-cart-open]")) { await getCart(); setDrawer(true); }
    if (event.target.closest("[data-cart-close]") || event.target === overlay) setDrawer(false);
    if (event.target.closest("[data-menu-open]")) { mobileMenu?.classList.add("open"); mobileMenu?.setAttribute("aria-hidden", "false"); document.body.classList.add("locked"); }
    if (event.target.closest("[data-menu-close]") || event.target.closest("[data-mobile-menu] a")) { mobileMenu?.classList.remove("open"); mobileMenu?.setAttribute("aria-hidden", "true"); document.body.classList.remove("locked"); }
  });
  document.addEventListener("keydown", (event) => { if (event.key === "Escape") { setDrawer(false); mobileMenu?.classList.remove("open"); document.body.classList.remove("locked"); } });
  window.addEventListener("scroll", updateHeader, { passive: true }); updateHeader();

  const revealItems = document.querySelectorAll(".intro > *, .section-heading, .product-card, .category-lead, .category-index nav a, .principles > *, .principle-list article, .newsletter > *");
  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add("is-visible"); observer.unobserve(entry.target); } }), { threshold: .1, rootMargin: "0px 0px -8% 0px" });
    revealItems.forEach((item, index) => { item.classList.add("reveal-on-scroll"); item.style.transitionDelay = `${(index % 3) * 70}ms`; observer.observe(item); });
  } else revealItems.forEach((item) => item.classList.add("is-visible"));

  getCart().catch(() => {});
})();
